export default "__VITE_PUBLIC_ASSET__39bb628a__"